import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMoon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMoon"><Path d="M22.0333 11.7226C20.8934 12.5273 19.5024 13 18.001 13C14.135 13 11.001 9.86598 11.001 5.99999C11.001 4.49859 11.4737 3.1076 12.2783 1.9677C12.1868 1.96523 12.095 1.96399 12.0029 1.96399C6.46119 1.96399 1.96875 6.45643 1.96875 11.9981C1.96875 17.5398 6.46119 22.0323 12.0029 22.0323C17.5446 22.0323 22.037 17.5398 22.037 11.9981C22.037 11.906 22.0358 11.8141 22.0333 11.7226Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMoon;
